import { ReturnActionType } from "../types/return-type";
import { HeaderFlagActionTypes } from "../types/header-flag";

export const headerFlag = (): ReturnActionType => ({ type: HeaderFlagActionTypes.HEADER_FLAG });
